import React from "react";
import { Stack } from "@mui/material";
import QuickFilter from "../../widgets/QuickFilter";
import ValueFilter from "../../widgets/ValueFilter";
import RangeFilter from "../../widgets/RangeFilter";
import { StoneFilters } from "./filters";
import { DiamondOptions } from "./useDiamondOptions";

// The line of filter chips both stone searches carry, identical on each: which stones are eligible,
// whatever the colour reference above it happens to be.
const StoneFilterBar = ({
  filters,
  onChange,
  options,
}: {
  filters: StoneFilters;
  onChange: (filters: StoneFilters) => void;
  options: DiamondOptions | undefined;
}) => {
  const set = (change: Partial<StoneFilters>) =>
    onChange({ ...filters, ...change });

  return (
    <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1 }}>
      <QuickFilter
        label="Available only"
        active={filters.availableOnly}
        toggle={(active) => set({ availableOnly: !active })}
      />
      <QuickFilter
        label="GIA only"
        active={filters.giaOnly}
        toggle={(active) => set({ giaOnly: !active })}
      />
      <QuickFilter
        label="Pattern calibrated only"
        active={filters.patternOnly}
        toggle={(active) => set({ patternOnly: !active })}
      />
      <ValueFilter
        label="Shape"
        value={filters.shape}
        options={options?.shapes ?? []}
        onChange={(shape) => set({ shape })}
      />
      <RangeFilter
        label="Price"
        value={filters.price}
        onChange={(price) => set({ price })}
      />
      <RangeFilter
        label="Carat"
        value={filters.carat}
        onChange={(carat) => set({ carat })}
      />
      <RangeFilter
        label="Clarity"
        value={filters.clarity}
        options={options?.clarities ?? []}
        onChange={(clarity) => set({ clarity })}
      />
    </Stack>
  );
};

export default StoneFilterBar;
